import createAuth0Client from '@auth0/auth0-spa-js'
import {createProps} from '@/components/user/OctUser.js'
import OctApiAdaptor from '@/components/api-adaptor/OctApiAdaptor.js';

const config = {
  domain: 'auth.marph.com',
  clientId: '8OSloMOLK5i5k5CcPoSVdidxkeKhzQcj',
  audience: 'http://localhost:8000'
}

export default {
  name: 'OctAuth',
  data () {
    return {
      /** User */
      user: createProps(),
      /** Auth0 Token */
      token: '',
      /** Whether authenticated */
      hasAuthentication: false,
      /** Whether authentication process is ended */
      initialized: false,
      /** Auth0 Client */
      $_octAuth_client: null,
      /** Auth0 User */
      $_octAuth_user: {},
    }
  },
  methods: {
    /** Get my data */
    async whoami () {
      let user = {}

      try {
        // Fetch my data
        const response = await OctApiAdaptor.getUser(null, this.token)

        // User data is fetched successfully and overwrite user data
        Object.assign(user, response)
      } catch (thrown) {
        if (thrown && thrown.code === 403) {
          // Over write user's email address if unauthorised 
          user.email = this.$data.$_octAuth_user.email
        } else {
          alert('システムエラーが発生しました(2)')
          console.log(thrown)
        }
      }

      return user
    },
    /** Initialization */
    async initialize () {
      this.initialized = true
    },
    /** Configure Auth0 client */
    async configureClient () {
      return await createAuth0Client({
        domain: config.domain,
        client_id: config.clientId,
        audience: config.audience,
        useRefreshTokens: true,
        cacheLocation: 'localstorage'
      })
    },
    /** Get Auth0 authentication */
    async isAuthenticated () {
      return await this.$data.$_octAuth_client.isAuthenticated()
    },
    /** Get Auth0 token */
    async getTokenSilently () {
      return await this.$data.$_octAuth_client.getTokenSilently()
    },
    /** Get Auth0 user */
    async getUser () {
      return await this.$data.$_octAuth_client.getUser()
    },
    /** Log the user out */
    signout (email=undefined) {
      // Return URL. If email is sat you will redirect to login page with user ID (email)
      const returnTo = email ? 
        `${window.location.origin}/account/settings` :
        `${window.location.origin}`

      // Set next login account
      email && sessionStorage.setItem('MARPH_CONTINUE_WITH', email)

      this.$data.$_octAuth_client.logout({
        returnTo: returnTo
      })
    }
  },
  async created () {
    let needRedirection = false // whether wait for browther reload

    // init auth0
    this.$data.$_octAuth_client = await this.configureClient()

    // token is not available
    try {
      // If the user is returning to the app after authentication..
      if (window.location.search.includes('code=') &&
        window.location.search.includes('state=')) {
        // handle the redirect and retrieve tokens
        await this.$data.$_octAuth_client.handleRedirectCallback();

        // Next step
        const returnURL = sessionStorage.getItem('MARPH_RETURN_URL')

        // Remove unnecessary url
        sessionStorage.removeItem('MARPH_RETURN_URL')

        if (returnURL) {
          // Replace history and redirect
          location.replace(returnURL)
          needRedirection = true
        } else {
          // Use replaceState to redirect the user away and remove the querystring parameters
          window.history.replaceState({}, document.title, location.pathname)
        }
      }
    } catch (thrown) {
      alert('認証に失敗しました')
    } finally {
      // Initialize our internal authentication state
      this.hasAuthentication = await this.isAuthenticated()

      if (!this.hasAuthentication) { // Can't authenticated
        // Store the current location
        sessionStorage.setItem('MARPH_RETURN_URL', location.href)
        // Next login account
        const continueWith = sessionStorage.getItem('MARPH_CONTINUE_WITH')

        // Remove unnecessary data
        sessionStorage.removeItem('MARPH_CONTINUE_WITH')

        // redirect to auth0 login
        await this.$data.$_octAuth_client.loginWithRedirect({
          redirect_uri: window.location.origin + (continueWith ?
            `/account/settings/?email=${continueWith}` : '/account/settings/'),
        })
      } else if (!needRedirection) { // Authenticated correctly
        // Get user and token
        this.$data.$_octAuth_user = await this.getUser();
        this.token = await this.getTokenSilently()

        // Authentication step finished and remove the stored return path
        sessionStorage.removeItem('MARPH_RETURN_URL')

        // Find me and update user object
        this.user = Object.assign({}, this.user, await this.whoami())

        // Get related accounts
        OctApiAdaptor.getRelatedAccounts(this.user.id, this.token)
          .then(response => {
            this.$set(this.user.data, 'relatedAccounts', response.items)
          })

        // Add user class
        if (this.user.id)
          document.documentElement.classList.add(`oct-auth--${this.user.type}`)

        // Initialize
        this.initialize()
      }
    }
  }
}
